var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#D4E8FD",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C12 2.74028 11.5978 3.38663 11 3.73244V5H17C18.1046 5 19 5.89543 19 7V9C19.5523 9 20 9.44771 20 10V12C20 12.5523 19.5523 13 19 13V16C19 17.1046 18.1046 18 17 18H3C1.89543 18 1 17.1046 1 16V13C0.447715 13 0 12.5523 0 12V10C0 9.44771 0.447715 9 1 9V7C1 5.89543 1.89543 5 3 5H9V3.73244C8.4022 3.38663 8 2.74028 8 2C8 0.895431 8.89543 0 10 0C11.1046 0 12 0.895431 12 2ZM6.5 11C7.32843 11 8 10.3284 8 9.5C8 8.67157 7.32843 8 6.5 8C5.67157 8 5 8.67157 5 9.5C5 10.3284 5.67157 11 6.5 11ZM15 9.5C15 10.3284 14.3284 11 13.5 11C12.6716 11 12 10.3284 12 9.5C12 8.67157 12.6716 8 13.5 8C14.3284 8 15 8.67157 15 9.5ZM14 15V13H6V15H14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/bot.58da4840053f76b7c4b9511547c18a66.svg";
export { ForwardRef as ReactComponent };